<script setup lang="ts">
    import { useForm, usePage } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import OnboardingStepForm from './OnboardingStepForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    import { OnboardingStep, SharedData } from '@/types';
    import type { Table } from '@tanstack/vue-table';

    defineProps<{
        table: Table<OnboardingStep>;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        service: '',
        other_title: '',
        description: '',
        allow_comments: false,
        allow_files: false,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.onboarding.store', { company: selectedCompanyId })"
        :query-key="[QueryKey.ONBOARDING, selectedCompanyId]"
        title="onboarding.create_step"
        button-text="onboarding.create_step"
    >
        <OnboardingStepForm
            :form="form"
            :table="table"
        />
    </DialogForm>
</template>
